import { AuthLoginComponent } from './core/components/authlogin/authlogin.component';
import { Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { DamageStepperComponent } from './features/damages/damage-stepper/damage-stepper.component';
import { WebComponentTestViewComponent } from './features/web-component-test-view/web-component-test-view.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./core/components/login/login.component').then((mod) => mod.LoginComponent),
    data: { title: 'TABS.LOGIN' }
  },
  // {
  //   path: '',
  //   redirectTo: 'login',
  //   pathMatch: 'full'
  // },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./core/components/authlogin/authlogin.component').then((mod) => mod.AuthLoginComponent),
    data: { title: 'TABS.LOGIN' }
  },
  {
    path: 'login',
    loadComponent: () => import('./core/components/login/login.component').then((mod) => mod.LoginComponent),
    data: { title: 'TABS.LOGIN' }
  },
  {
    path: 'app',
    loadChildren: () => import('./core/main/main.routes').then((mod) => mod.MAIN_ROUTES)
  },
  {
    path: 'test-web-component',
    component: WebComponentTestViewComponent
  }
  // { path: '404', component: LoginComponent },
  // { path: '**', component: LoginComponent }
];
